const EditUnderline = ({ color }: { color?: string }) => (
    <svg width="24" height="24" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2.3335 14L8.3335 14L14.3335 14" stroke={color ?? "#919EAB"} stroke-opacity="0.8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M8.48154 3.88559L10.3672 1.99997L13.667 5.2998L11.7814 7.18542M8.48154 3.88559L4.84144 7.52569C4.6539 7.71323 4.54855 7.96758 4.54855 8.2328L4.54855 11.1184L7.43416 11.1184C7.69938 11.1184 7.95373 11.0131 8.14127 10.8255L11.7814 7.18542M8.48154 3.88559L11.7814 7.18542" stroke={color ?? "#919EAB"} stroke-opacity="0.8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
);

export default EditUnderline;
